import { dataPlusSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlusSquare = /*#__PURE__*/createIcon(dataPlusSquare)
export default IconPlusSquare
